import React from 'react';
import { EsriCredentialSource } from '../esri-identity';
import { EsriIdentityContext } from '../esri-identity-context';

/**
 * How the most recently resolved Esri credential was scoped, or undefined if the OAuth
 * token path is off or nothing has resolved yet. Must be read from within
 * EsriConfiguration's subtree.
 */
export function useEsriIdentityCredentialSource(): EsriCredentialSource | undefined {
    const identity = React.useContext(EsriIdentityContext);
    if (!identity) {
        throw new Error('Unexpectedly did not find EsriIdentity on context.');
    }
    return identity.credentialSource;
}
